<template>
  <section class="productHeader">
    <div class="flex justify-center">
      <div class="w-full md:w-2/3 sm:w-3/4 flex flex-col justify-center items-center text-center px-3">
        <div class="text-lg" v-if="beforeHeader">{{ beforeHeader }}</div>
        <h1 class="block w-full">{{ header }}</h1>
        <p>{{ text }}</p>
        <button
            v-if="shows"
            class="btn blue-btn inline-flex"
            @click="$vfm.show('example')"
        ><span>{{ $t("ui.getStarted") }}</span></button>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "ProductHeader",
  props: {
    header: String,
    beforeHeader: String,
    text: String,
    shows: Boolean
  }
}
</script>
